import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const EMPLOYMENT_OPTIONS = [
  'アルバイト（雇用契約）',
  '業務委託',
  'どちらでも可',
];

const WEEKDAY_OPTIONS = ['月', '火', '水', '木', '金', '土', '日'];

const INTEREST_OPTIONS = [
  '業務内容に興味がある',
  'フルリモートで働きたい',
  'AIツールを使った仕事に興味がある',
  'スキルを活かして復職したい',
  '副業として取り組みたい',
  '知人の紹介',
  'その他',
];

const LEAVE_REASON_OPTIONS = [
  '出産・育児',
  '介護',
  '配偶者の転勤',
  '会社都合（倒産・リストラ等）',
  '待遇への不満',
  'キャリアチェンジ',
  '体調・健康上の理由',
  '現在就業中',
  'その他',
];

const DESIRE_OPTIONS = [
  'ぜひ働きたい',
  '条件が合えば働きたい',
  '迷っている点がある',
];

const GAS_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwR4Mzv2wYR-ygoWh2eLQZf4ia57GBtidXBAVZeR2_pg4IFVOR2dnhI-mukRQZRkaXB3Q/exec';

function RecruitSurveyPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    employmentType: '',
    availableDays: [],
    availableTimeFrom: '',
    availableTimeTo: '',
    desiredIncome: '',
    interestReason: '',
    interestDetail: '',
    leaveReason: '',
    leaveDetail: '',
    strengthWeakness: '',
    otherApplications: '',
    desire: '',
    desireDetail: '',
    startDate: '',
    pcOS: '',
    internetSpeed: '',
    note: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckbox = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      availableDays: checked
        ? [...prev.availableDays, value]
        : prev.availableDays.filter(d => d !== value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      if (GAS_ENDPOINT) {
        await fetch(GAS_ENDPOINT, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            formType: 'survey',
            ...formData,
            availableDays: formData.availableDays.join(', '),
            submittedAt: new Date().toISOString(),
          }),
        });
      }
      setSubmitted(true);
    } catch (err) {
      setError('送信中にエラーが発生しました。お手数ですが、しばらくしてから再度お試しください。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="page-header">
        <Container>
          <h1 className="page-title">Survey</h1>
          <p className="page-subtitle">面接事前調査票</p>
        </Container>
      </section>

      <section className="section-contact-before">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="before-content">
                <h3>書類選考を通過された方へ</h3>
                <p>
                  面接の前に、以下の調査票へのご回答をお願いしております。<br />
                  いただいた情報は、面接をより有意義な時間にするために使用いたします。
                </p>
                <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginTop: '1.5em' }}>
                  ※ 記入に抵抗のある項目は空欄で構いません。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-contact-form">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              {submitted ? (
                <div style={{ textAlign: 'center', padding: '60px 0' }}>
                  <h3 style={{ fontSize: '1.4rem', fontWeight: 300, color: 'var(--text-primary)', marginBottom: '16px' }}>
                    ご回答ありがとうございます。
                  </h3>
                  <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 2 }}>
                    内容を確認し、面接日程のご連絡をいたします。<br />
                    しばらくお待ちください。
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <p style={{ fontSize: '12px', color: 'var(--gold)', marginBottom: '2em' }}>
                    <span style={{ color: 'var(--gold)' }}>*</span> は必須項目です
                  </p>

                  <div className="form-group">
                    <label>氏名 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="山田 花子" />
                  </div>

                  <div className="form-group">
                    <label>メールアドレス <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="example@email.com" />
                  </div>

                  {/* 雇用形態 */}
                  <div className="form-group">
                    <label>希望する雇用形態 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <select name="employmentType" value={formData.employmentType} onChange={handleChange} required>
                      <option value="">選択してください</option>
                      {EMPLOYMENT_OPTIONS.map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  {/* 稼働可能な曜日 */}
                  <div className="form-group">
                    <label>稼働可能な曜日 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '8px' }}>
                      {WEEKDAY_OPTIONS.map(day => (
                        <label key={day} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '15px', color: 'var(--text-secondary)', cursor: 'pointer' }}>
                          <input
                            type="checkbox" value={day}
                            checked={formData.availableDays.includes(day)}
                            onChange={handleCheckbox}
                            style={{ accentColor: 'var(--gold)' }}
                          />
                          {day}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* 稼働可能な時間帯 */}
                  <div className="form-group">
                    <label>稼働可能な時間帯</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input type="time" name="availableTimeFrom" value={formData.availableTimeFrom} onChange={handleChange} style={{ flex: 1 }} />
                      <span style={{ color: 'var(--text-tertiary)' }}>〜</span>
                      <input type="time" name="availableTimeTo" value={formData.availableTimeTo} onChange={handleChange} style={{ flex: 1 }} />
                    </div>
                  </div>

                  {/* 希望収入 */}
                  <div className="form-group">
                    <label>希望する月収（目安）</label>
                    <input type="text" name="desiredIncome" value={formData.desiredIncome} onChange={handleChange} placeholder="例: 10万円程度、特に希望なし" />
                    <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginTop: '6px' }}>
                      参考情報としてお伺いしています。選考には影響しません。
                    </p>
                  </div>

                  {/* 興味を持った理由 */}
                  <div className="form-group">
                    <label>当社に興味を持った理由 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <select name="interestReason" value={formData.interestReason} onChange={handleChange} required>
                      <option value="">選択してください</option>
                      {INTEREST_OPTIONS.map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>上記の詳細（自由記述）</label>
                    <textarea name="interestDetail" value={formData.interestDetail} onChange={handleChange} placeholder="具体的に教えていただけると、面接でより深い話ができます" style={{ minHeight: '100px' }} />
                  </div>

                  {/* 前職を辞めた理由 */}
                  <div className="form-group">
                    <label>前職を離れた理由</label>
                    <select name="leaveReason" value={formData.leaveReason} onChange={handleChange}>
                      <option value="">選択してください</option>
                      {LEAVE_REASON_OPTIONS.map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>上記の詳細（自由記述）</label>
                    <textarea name="leaveDetail" value={formData.leaveDetail} onChange={handleChange} placeholder="差し支えない範囲でお書きください" style={{ minHeight: '80px' }} />
                  </div>

                  {/* 長所・短所 */}
                  <div className="form-group">
                    <label>ご自身の長所と短所 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <textarea name="strengthWeakness" value={formData.strengthWeakness} onChange={handleChange} required placeholder={"例:\n長所: 一度決めたことは最後までやり遂げる粘り強さがあります\n短所: 細かいことが気になりすぎて、作業に時間がかかることがあります"} style={{ minHeight: '120px' }} />
                  </div>

                  {/* 併願状況 */}
                  <div className="form-group">
                    <label>他社への応募状況</label>
                    <input type="text" name="otherApplications" value={formData.otherApplications} onChange={handleChange} placeholder="例: 2社応募中、なし" />
                  </div>

                  {/* 入社希望度 */}
                  <div className="form-group">
                    <label>現時点での入社希望度 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <select name="desire" value={formData.desire} onChange={handleChange} required>
                      <option value="">選択してください</option>
                      {DESIRE_OPTIONS.map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>迷っている点や確認したいことがあれば</label>
                    <textarea name="desireDetail" value={formData.desireDetail} onChange={handleChange} placeholder="面接時にお答えします" style={{ minHeight: '80px' }} />
                  </div>

                  {/* 稼働開始可能日 */}
                  <div className="form-group">
                    <label>稼働開始可能日 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="text" name="startDate" value={formData.startDate} onChange={handleChange} required placeholder="例: 即日可能、2026年5月1日〜" />
                  </div>

                  {/* PC環境 */}
                  <div style={{ borderTop: '1px solid var(--gold-border)', margin: '40px 0 30px', paddingTop: '30px' }}>
                    <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginBottom: '1.5em' }}>
                      リモートワーク環境の確認
                    </p>
                  </div>

                  <div className="form-group">
                    <label>お使いのPC（OS） <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="text" name="pcOS" value={formData.pcOS} onChange={handleChange} required placeholder="例: Windows 11、MacBook Air M2" />
                  </div>

                  <div className="form-group">
                    <label>インターネット回線</label>
                    <input type="text" name="internetSpeed" value={formData.internetSpeed} onChange={handleChange} placeholder="例: 光回線（自宅）、ポケットWi-Fi" />
                  </div>

                  {/* その他 */}
                  <div className="form-group">
                    <label>その他伝えたいこと</label>
                    <textarea name="note" value={formData.note} onChange={handleChange} placeholder="ご質問やアピールしたいことがあればお書きください" style={{ minHeight: '100px' }} />
                  </div>

                  {error && (
                    <p style={{ color: '#e74c3c', fontSize: '14px', marginBottom: '16px' }}>{error}</p>
                  )}

                  <div style={{ textAlign: 'center', marginTop: '40px' }}>
                    <button type="submit" className="btn-primary-custom" disabled={submitting}>
                      {submitting ? '送信中...' : '送信する'}
                    </button>
                  </div>
                </form>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default RecruitSurveyPage;
